module.exports = __webpack_public_path__ + "media/images/imap_accounts/icon_docomo-513615e8c74a4985cc07cf6ad5843d55.png";